import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for J514 (R&D PO Approval)
// ============================================================

export interface PendingItem {
  fj510_01: string;       // 採購單號
  fj510_11: string | null; // 採購日期 (ISO string)
  supplier_name: string;  // 供應商名稱
  product_code: string;   // 產品代號+副碼
  fj510_21: string | null; // 交貨日期
  fj510_29: number;       // 採購金額
  fj510_80: string;       // 核准狀態
  can_approve: boolean;   // 是否可核准
}

export interface QueryResponse {
  items: PendingItem[];
  total: number;
  level: string;
}

export interface ApproveResultItem {
  po_no: string;
  success: boolean;
  message: string;
  new_stat: string;
}

export interface ExecuteResponse {
  results: ApproveResultItem[];
  success: number;
  failed: number;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const j514Api = {
  /** Query pending R&D PO items within a range */
  async query(startNo: string, endNo: string): Promise<QueryResponse> {
    const res = await apiClient.post('/api/j514/query', {
      start_no: startNo,
      end_no: endNo,
    });
    return res.data;
  },

  /** Execute batch approval for selected R&D PO items */
  async execute(poNos: string[]): Promise<ExecuteResponse> {
    const res = await apiClient.post('/api/j514/execute', {
      po_nos: poNos,
	  confirmed: true,
    });
    return res.data;
  },
};
